import { render } from "./EndView.vue?vue&type=template&id=7036e4cd&scoped=true"
import script from "./EndView.vue?vue&type=script&lang=js"
export * from "./EndView.vue?vue&type=script&lang=js"

import "./EndView.vue?vue&type=style&index=0&id=7036e4cd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7036e4cd"]])

export default __exports__